

























import { listFactory } from '@/main/pages';

import { formatDate } from '@/main/utils/dateFormatter';

import { NAME } from './constants';
import { DropDownListItem, store } from './store/list';
import { apiProvider } from './api';


export default listFactory(NAME, store).extend({
	data() {
		return {
			parameters: 'null' as string,
			selectedWorkshops: [] as number[],
			selectedTechnicians: [] as number[],
		};
	},
	methods: {
		async onWorkShopChange(workshopId: number) {			
			if (workshopId !== undefined) {
				this.TechnicianIds = [];
				const { data } = await apiProvider.GetTechnicianList(this.filter.LocationIds);
				this.dropdownList.TechnicianList = data;
			}
		},		

		async exportFun() {
			try {
				this.startLoading();
				const urlParameters: string = this.GetParameters(this.filter.FromDate, this.filter.ToDate, this.filter.LocationIds, this.filter.TechnicianIds);
				await apiProvider.GetTimeClockingReport(urlParameters);
			} finally {
				this.endLoading();
			}
		},

		GetParameters(fromDate : any, toDate : any, LocationIds: any, TechnicianIds: any) {
			const fromDatetime = formatDate(fromDate);
			const toDatetime = formatDate(toDate);
			this.parameters = '';
			this.parameters = this.parameters.concat(`FromDate=${fromDatetime}&ToDate=${toDatetime}&LocationIds=${LocationIds}`);
			
			if (TechnicianIds.length > 0) {
				TechnicianIds.forEach((TechnicianId: any) => {
					this.parameters = this.parameters.concat(`&TechnicianIds=${TechnicianId}`);
				});
			}
			return this.parameters;
		},
		dateValidation() {
			if (this.FromDate && this.ToDate) {
				const startMonth = this.FromDate.getMonth();
				const endMonth = this.ToDate.getMonth();
				const startYear = this.FromDate.getFullYear();
				const endYear = this.ToDate.getFullYear();
				if (startMonth !== endMonth || startYear !== endYear) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DP_DATETOFROM_MONTH_VALIDATION') });
					const date = new Date();
					this.FromDate = new Date(date.getFullYear(), date.getMonth(), 1);
					this.ToDate = date;
					return false;
				}
			} else {
				return false;
			}
			return true;
		},
	},
	mounted() {
		const element = document.getElementsByClassName('el-main');
		if (element.length !== 0) element[0].classList.remove('d-flex');
	},
});
